import { render } from "./Login-Admin.vue?vue&type=template&id=3c7979de&scoped=true"
import script from "./Login-Admin.vue?vue&type=script&lang=js"
export * from "./Login-Admin.vue?vue&type=script&lang=js"

import "./Login-Admin.vue?vue&type=style&index=0&id=3c7979de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c7979de"]])

export default __exports__